import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputNumber } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import SampleCategoryWriteDTO from '../../../../../../types/sample-category/SampleCategoryWriteDTO';
import { SampleCategoryService } from '../../../../services/sample-category.service';

@Component({
    selector: 'app-update-sample-category-dialog',
    templateUrl: './update-sample-category-dialog.component.html',
    styleUrls: [ './update-sample-category-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        InputNumber,
    ]
})
export class UpdateSampleCategoryDialogComponent {
    @Input() visible: boolean = false;
    @Input() sampleCategory: SampleCategoryWriteDTO = new SampleCategoryWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() sampleCategoryUpdated: EventEmitter<SampleCategoryWriteDTO> = new EventEmitter<SampleCategoryWriteDTO>();

    constructor(private sampleCategoryService: SampleCategoryService,
                private messageService: MessageService) {
    }

    public loading = false;

    get saveDisabled(): boolean {
        return !this.sampleCategory?.name;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public updateSampleCategory() {
        this.loading = true;

        this.sampleCategoryService.updateSampleCategory(this.sampleCategory).then(() => {
            this.sampleCategoryUpdated.emit(this.sampleCategory);
            this.close();
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        }).finally(() => {
            this.loading = false;
        });
    }
}
